/**
 * 模板状态枚举
 */
export enum TemplateState {
  Draft = 0,
  Scheduled = 100,
  InReview = 200,
  Reject = 300,
  Online = 401,
  Offline = 600,
}

export interface TemplateStateInfo {
  label: string;
  color: string;
  className: string;
}

export const TEMPLATE_STATE_MAP: Record<number, TemplateStateInfo> = {
  [TemplateState.Draft]: {
    label: "Draft",
    color: "secondary",
    className: "bg-secondary",
  },
  [TemplateState.Scheduled]: {
    label: "Scheduled",
    color: "yellow-500",
    className: "bg-yellow-500",
  },
  [TemplateState.InReview]: {
    label: "InReview",
    color: "primary",
    className: "bg-primary",
  },
  [TemplateState.Reject]: {
    label: "Reject",
    color: "destructive",
    className: "bg-destructive",
  },
  [TemplateState.Online]: {
    label: "Online",
    color: "primary",
    className: "bg-primary",
  },
  [TemplateState.Offline]: {
    label: "Offline",
    color: "red-500",
    className: "bg-red-500",
  },
};

/**
 * 获取状态信息
 */
export function getTemplateStateInfo(state?: number): TemplateStateInfo | null {
  if (state === undefined || state === null) {
    return null;
  }
  return TEMPLATE_STATE_MAP[state] || null;
}

